import styled from "styled-components";
import React from "react";

const CloseFailureMessage = styled.div`
    padding: 3px;
    background-color: #8f1717;
    text-align: Center;
    color: White;
`;

export const CloseFailure = ({error}) => {
    if (!error) return null;

    return (<CloseFailureMessage className="t-idea-action-error">
        {error}
    </CloseFailureMessage>);
};